<header class="header">
  <!-- Mobile menu overlay -->
  <div class="header__overlay" [class.active]="mobileMenuOpen" (click)="closeMobileMenu()"></div>

  <div class="container">
    <div class="header__content">
      <div class="logo">
        <a routerLink="/">
          <img src="assets/img/logo.svg" alt="{{ 'app.title' | transloco }}" />
        </a>
      </div>
      <nav class="nav">
        <ul class="nav__list">
          <li class="nav__item">
            <a [routerLink]="getLocalizedRoute('/')" class="nav__link" [class.active]="isRouteActive('/')">{{ 'nav.findJobs' | transloco }}</a>
          </li>
          <li class="nav__item">
            <a [routerLink]="getLocalizedRoute('/companies')" class="nav__link" [class.active]="isRouteActive('/companies')">
              {{ 'nav.companies' | transloco }}
            </a>
          </li>
          <li class="nav__item">
            <a [routerLink]="getLocalizedRoute('/market-analytics')" class="nav__link" [class.active]="isRouteActive('/market-analytics')">
              {{ 'nav.marketAnalytics' | transloco }}
            </a>
          </li>
          <li class="nav__item">
            <a [routerLink]="getLocalizedRoute('/market-predictions')" class="nav__link" [class.active]="isRouteActive('/market-predictions')">
              {{ 'nav.marketPredictions' | transloco }}
            </a>
          </li>
        </ul>
      </nav>
      <div class="header__actions" [class.mobile-open]="mobileMenuOpen">
        <button class="header__mobile-close" (click)="closeMobileMenu()" aria-label="Close menu" type="button">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>

        <!-- 1. ACCOUNT (most important): Profile button + user info + actions -->
        <div class="header__actions-buttons">
          @if (isLoggedIn()){
          <app-button size="md" [routerLink]="getLocalizedRoute('/profile')" variant="filled" color="primary" (click)="closeMobileMenu()">{{ 'nav.yourProfile' | transloco }}</app-button>
          } @else {
          <app-button size="md" [href]="dashboardUrl" target="_blank" rel="noopener noreferrer" variant="filled" color="primary" (click)="closeMobileMenu()">{{ 'nav.forCompanies' | transloco }}</app-button>
          <app-button size="md" [routerLink]="getLocalizedRoute('/login')" variant="outline" color="primary" (click)="closeMobileMenu()">{{ 'nav.login' | transloco }}</app-button>
          }
          @if (isLoggedIn()) {
          <!-- Desktop: popover dropdown (collapsed by default, expands on click) -->
          <app-user-dropdown
            class="header__user-dropdown--desktop"
            [userName]="getUserName()"
            [userEmail]="getUserEmail()"
            [firstName]="firstName"
            [lastName]="lastName"
            [photo]="avatarPhoto"
            [profileLink]="getLocalizedRoute('/profile')"
            [myJobsLink]="getLocalizedRoute('/jobs')"
            [settingsLink]="getLocalizedRoute('/settings')">
          </app-user-dropdown>
          <!-- Mobile drawer: rendered inline, no profile link (orange CTA above) -->
          <app-user-dropdown
            class="header__user-dropdown--mobile"
            [inline]="true"
            [userName]="getUserName()"
            [userEmail]="getUserEmail()"
            [firstName]="firstName"
            [lastName]="lastName"
            [photo]="avatarPhoto"
            [myJobsLink]="getLocalizedRoute('/jobs')"
            [settingsLink]="getLocalizedRoute('/settings')">
          </app-user-dropdown>
          }
        </div>

        <!-- 2. NAVIGATION: main app sections -->
        <nav class="nav nav--mobile">
          <ul class="nav__list">
            <li class="nav__item">
              <a [routerLink]="getLocalizedRoute('/')" class="nav__link" [class.active]="isRouteActive('/')" (click)="closeMobileMenu()">
                <i class="fas fa-search nav__icon" aria-hidden="true"></i>
                <span>{{ 'nav.findJobs' | transloco }}</span>
              </a>
            </li>
            <li class="nav__item">
              <a [routerLink]="getLocalizedRoute('/companies')" class="nav__link" [class.active]="isRouteActive('/companies')" (click)="closeMobileMenu()">
                <i class="fas fa-building nav__icon" aria-hidden="true"></i>
                <span>{{ 'nav.companies' | transloco }}</span>
              </a>
            </li>
            <li class="nav__item">
              <a [routerLink]="getLocalizedRoute('/market-analytics')" class="nav__link" [class.active]="isRouteActive('/market-analytics')" (click)="closeMobileMenu()">
                <i class="fas fa-chart-line nav__icon" aria-hidden="true"></i>
                <span>{{ 'nav.marketAnalytics' | transloco }}</span>
              </a>
            </li>
            <li class="nav__item">
              <a [routerLink]="getLocalizedRoute('/market-predictions')" class="nav__link" [class.active]="isRouteActive('/market-predictions')" (click)="closeMobileMenu()">
                <i class="fas fa-lightbulb nav__icon" aria-hidden="true"></i>
                <span>{{ 'nav.marketPredictions' | transloco }}</span>
              </a>
            </li>
          </ul>
        </nav>

        <!-- 3. LANGUAGE (least important): pinned to bottom -->
        <!-- Desktop: popover; mobile drawer: inline list -->
        <app-language-dropdown class="header__lang header__lang--desktop"></app-language-dropdown>
        <app-language-dropdown class="header__lang header__lang--mobile" [inline]="true"></app-language-dropdown>
      </div>
      <button mat-icon-button class="header__mobile-toggle" (click)="toggleMobileMenu()" aria-label="Menu" type="button">
        <i class="fas fa-bars" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</header>
